import React, {Component} from "react";
import {reqOptTypes,} from "../../api";
import Order from './order'
import OrderMonth from './order-month'

class Timeliness extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    getOptTypes = async (deliveryType) => {
        const result = await reqOptTypes({deliveryType});
        if (result.code == '200') {
            this.setState({optTypes: result.data});
        }
    };

    componentDidMount() {
        const deliveryType = this.props.match.params.deliveryType;
        this.setState({deliveryType});
        this.getOptTypes(deliveryType);
    }

    render() {
        const {optTypes, deliveryType} = this.state;
        return (
            <div className='home-page'>
                <Order {...this.props} optTypes={optTypes} deliveryType = {deliveryType} />
                <OrderMonth {...this.props} optTypes={optTypes} deliveryType = {deliveryType}/>
                <Order {...this.props} optTypes={optTypes} deliveryType = {deliveryType}/>
                <OrderMonth {...this.props} optTypes={optTypes} deliveryType = {deliveryType}/>
            </div>
        )
    }
}

export default Timeliness;